import moment from 'moment';
import {
  GRANULARITY,
  GRANULARITY_TO_METRICS_SEARCH_GRANULARITY
} from '../consts/granularity';
import { SEARCH_DATE_FORMAT, VIEW_PATH_KEYS } from 'common/constants/constants';
import { METRICS_GROUP_BY_API_PARAMS } from '../consts/groupBy';
import { isEqualAllTeams } from '../../Filters/TeamsDropdown';
import { getGranularityAccordingToDatesAndChoice } from './granularity';
import {
  GRANULARITY_TO_METRICS_V2_GRANULARITY,
  GROUP_BY_KEY
} from '../../consts';
import { getIsGitScopeByKey } from 'components/TeamGitScopeBanner/utils';
import { isReportOrgLevelOnly } from '../../custom-report.util';

const getGroupByForSearch = ({ customMetrics, globallySelectedTeams }) => {
  if (customMetrics?.length) {
    return METRICS_GROUP_BY_API_PARAMS.CUSTOM_METRIC;
  }
  if (!isEqualAllTeams(globallySelectedTeams)) {
    return METRICS_GROUP_BY_API_PARAMS.TEAM;
  }
  return METRICS_GROUP_BY_API_PARAMS.ORGANIZATION;
};

const buildSearchOptionsForGraph = ({
  reportDefinition,
  filters: {
    selectedRepo,
    selectedContributor,
    selectedService,
    selectedGranularity,
    selectedTimeRanges,
    globallySelectedTeams,
    searchRange,
    selectedLabels
  },
  gitScopeToggle = null,
  metrics,
  customMetrics,
  reportedMetrics
}) => {
  const { granularity } = getGranularityAccordingToDatesAndChoice(
    selectedTimeRanges?.start_date,
    selectedTimeRanges?.end_date,
    selectedGranularity,
    true
  );

  const orgLevelOnlyMetricsOptions = {
    roll_up: GRANULARITY_TO_METRICS_V2_GRANULARITY[granularity],
    time_ranges: searchRange,
    requested_metrics: metrics
  };

  const customMetricsOptions = customMetrics
    ? {
        group_by: METRICS_GROUP_BY_API_PARAMS.CUSTOM_METRIC,
        roll_up: GRANULARITY_TO_METRICS_V2_GRANULARITY[granularity],
        time_ranges: searchRange,
        custom_metrics: customMetrics?.filter(
          ({ filters }) => filters?.issue_types && filters?.issue_states
        )
      }
    : null;

  const reportedMetricsOptions = reportedMetrics
    ? {
        group_by: METRICS_GROUP_BY_API_PARAMS.ORGANIZATION,
        roll_up: GRANULARITY_TO_METRICS_V2_GRANULARITY[granularity],
        time_ranges: searchRange,
        requested_metrics: reportedMetrics
      }
    : null;

  const metricsOptions = {
    ...(selectedContributor && {
      contributor_ids: [selectedContributor.id]
    }),
    team_ids: !isEqualAllTeams(globallySelectedTeams)
      ? globallySelectedTeams.map(team => team.id)
      : [],
    ...(selectedRepo && selectedRepo.length
      ? { repository_ids: selectedRepo }
      : {}),
    ...(selectedService && selectedService.length
      ? { service_ids: selectedService }
      : {}),
    ...(selectedLabels && selectedLabels.length
      ? { labels: selectedLabels }
      : {}),
    // this is a temp fix until we have the supported UI for cross filters
    group_by: selectedLabels?.length
      ? GROUP_BY_KEY.LABEL
      : getGroupByForSearch({
          customMetrics,
          globallySelectedTeams
        }),
    requested_metrics: metrics,
    roll_up: GRANULARITY_TO_METRICS_V2_GRANULARITY[granularity],
    time_ranges: searchRange,
    // gitScopeToggle null means Metrics; gitScopeToggle not null means Team Goals
    ...(gitScopeToggle === null
      ? { team_git_scope_disabled: true }
      : {
          team_git_scope_disabled: !getIsGitScopeByKey(
            gitScopeToggle,
            VIEW_PATH_KEYS.TEAM_GOALS
          )
        })
  };
  return {
    metricsOptions: isReportOrgLevelOnly(reportDefinition)
      ? orgLevelOnlyMetricsOptions
      : customMetricsOptions ?? reportedMetricsOptions ?? metricsOptions,
    averageOptions: {
      ...metricsOptions,
      roll_up:
        GRANULARITY_TO_METRICS_SEARCH_GRANULARITY[GRANULARITY.ITERATIONS],
      group_by: METRICS_GROUP_BY_API_PARAMS.ORGANIZATION,

      time_ranges: [
        {
          before: moment
            .min(moment(selectedTimeRanges.end_date), moment())
            .format(SEARCH_DATE_FORMAT),
          after: selectedTimeRanges.start_date
        }
      ]
    }
  };
};

export default buildSearchOptionsForGraph;
